import _get from 'lodash/get';
import getCommaSeparatedList from './getCommaSeparatedList';
export default function translateDataLayerConsumerAdTargetsWithoutCAMPBias() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    intent: _get(data, 'targetIntent', 'INCONCLUSIVE'),
    preferredMakes: getCommaSeparatedList(data, 'targetMakes', 'makes', 'make') || 'INCONCLUSIVE',
    preferredModel: getCommaSeparatedList(data, 'targetModels', 'models', 'model', 1) || 'INCONCLUSIVE',
    secondPreferredModel: getCommaSeparatedList(data, 'targetModels', 'models', 'model', 2) || 'INCONCLUSIVE',
    subCategory: getCommaSeparatedList(data, 'targetSegments', 'segments', 'segment') || 'INCONCLUSIVE',
    tradeInMake: _get(data, 'targetTradeInVehicle.make.desc', 'INCONCLUSIVE'),
    tradeInModel: _get(data, 'targetTradeInVehicle.model.desc', 'INCONCLUSIVE')
  };
}